"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ldpObject.js.map